export function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/progress/utils.js
// module id = 204
// module chunks = 0